<template>
  <div>
    <!-- Calendario de activadades de la seccion -->
    <component :is="tipoComponente2" :modalCrearActividad="estadoModalCrear" @close2="estadoModalCrear = false"
      @actvidades_actualizar="loadMain()" :datosSeccion="datosClase" :fechaActual="fechaSeleccionada"
      :eventoAct="eventoActividad"></component>

    <ComunDialogComp v-model="modalActividad" maxWidth="1200" title="Actividades académicas programadas"
      @close-modal="$emit('close')">
      <template v-slot:body>
        <ComundataTablecomp :search="search" whitSearch :items="actividadesDocenteFilter"
          :headers="ActividadesDocenteHeader" itemkey="id_actividad">

          <template v-slot:desc_curso="{ item }">
            <v-chip class="pr-0 pl-2" color="white">
              <v-avatar left :color="item.color_curso">
                <v-icon x-small color="white">{{
                  item.icono_curso
                }}</v-icon>
              </v-avatar>

              <span class="font-weight-black px-0">{{
                item.desc_curso
              }}</span>
            </v-chip>
          </template>
          <template v-slot:fec_us_ing_actividad="{ item }">
            <span>{{ item.fec_us_ing_actividad | filtroFecha }}</span>
          </template>
          <template v-slot:fecha_actividad="{ item }">
            <span>{{ item.fecha_actividad | filtroFecha }}</span>
          </template>
          <template v-slot:hora_fin_actividad="{ item }">
            <span>{{
              item.hora_fin_actividad | filtroFormatoHora
            }}</span>
          </template>
          <template v-slot:editar_actividad="{ item }">
            <ButtonComp editButton v-if="componenteEvento.editar_submodulo" :disabled="new Date().toISOString().substr(0, 10) >
              new Date(item.fecha_actividad)
                .toISOString()
                .substr(0, 10)
              " @click="editItem(item)" tooltipText="Editar actividad" />
          </template>
          <template v-slot:evaluar_actividad="{ item }">
            <ButtonComp v-if="componenteEvento.editar_submodulo" listButton @click="evaluarItem(item)"
              tooltipText="Evaluar actividad" />
          </template>
        </ComundataTablecomp>
      </template>
    </ComunDialogComp>


    <v-form ref="formDatos" lazy-validation>
      <ComunDialogComp v-model="modal_evaluarActividad" maxWidth="1000" @close-modal="modal_evaluarActividad = false">
        <template v-slot:title>
          Evaluar actividad -
          <v-chip dark class="ml-2" :color="tituloEvalucionNivelColor">
            <span class="font-weight-black">Nivel: {{ tituloEvalucionNivel }}
              {{ tituloEvalucionGrado }}</span>
          </v-chip>
        </template>
        <template v-slot:body>
          <v-row>
            <v-col>
            </v-col>
            <v-col cols="12">
              <ComundataTablecomp :headers="EvaluaractividadHeaders" :items="AlumnosSeccion" :search="search"
                whitSearch>
                <template v-slot>
                  <v-chip small>
                    Lista de estudiantes de la sección:
                    {{ tituloEvalucionSeccion }}
                  </v-chip>
                </template>
                <template v-slot:apellido_nombre="{ item }">
                  <span>{{
                    item.ape1_alumno + ' ' + item.ape2_alumno + ' ' + item.nombre_alumno
                  }}</span>
                </template>

                <template v-slot:action_descargar="{ item }">
                  <ButtonComp v-if="componenteEvento.visualizar_submodulo && item.ruta_alumno != null" @click="download(
                    URL_SPACE + '/' + item.ruta_alumno)" downloadButton
                    tooltipText="Descargar archivo de actividad asignada" />
                  <v-chip v-else>
                    Sin actividad
                  </v-chip>

                </template>
                <template v-slot:calificacion="{ item }">
                  <v-autocomplete label="Calificación" class="pb-0 pt-1" dense eager append-icon="fas fa-sort-down"
                    v-model="item.calificacion_revision" :items="tipoNotasCalificacion" autocomplete="on"
                    item-value="nota_desc" item-text="nota_desc">
                  </v-autocomplete>
                </template>

                <template v-slot:observacion="{ item }">
                  <v-textarea v-model="item.observacion_revision" label="Observación" class="pb-0 pt-1" single-line
                    :disabled="item.alumno_check == false" rows="3"></v-textarea>
                </template>

                <template v-slot:estadoValor="{ item }">
                  <v-chip small dark class="font-weight-black" :color="item.color_estado_docente">
                    {{ item.desc_estado_docente }}
                  </v-chip>
                </template>
              </ComundataTablecomp>

            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <ButtonComp @click="saveItem" textButton="Guardar" iconBut="fas fa-save" normalButton />
          <ButtonComp @click="modal_evaluarActividad = false" textButton="Cancelar" classColor="red" classButton="ml-2"
            normalButton />

        </template>
      </ComunDialogComp>

    </v-form>
    <!-- fin modal evaluar actividad -->
  </div>
</template>

<script>
import axios, { API_URL } from "@/helpers/axios";
// import url from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import ModalCrearActividades from "./CrearActividad.vue";
import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue';
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import { ActividadesDocenteHeader, EvaluaractividadHeaders } from '../../../../helpers/headersTable';
import { BUCKET_ORIGIN_SPACE } from "@/helpers/axios";

export default {
  name: "modalVerActividadDocente",

  components: {
    ModalCrearActividades,
    ComunDialogComp,
    ComundataTablecomp,
    ButtonComp,

  },

  props: ["modalActividad"],

  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 26, id_modulo: 7 }, //sud_modulo y modulo

    datoLogin: sessionStorage, // variables de sesion del usuario
    test: false,
    ruta_api: API_URL, // ruta del servidor
    ////////////////////////////////////////////////////////

    //Descargar archivos del SPACE
    URL_SPACE: BUCKET_ORIGIN_SPACE,

    actividadesDocente: [],
    actividadesDocenteFilter: [],
    search: "",
    ActividadesDocenteHeader,
    EvaluaractividadHeaders,

    /////////////////////////////////////

    // componente calendario de actividades por seccion
    tipoComponente2: "",
    modalCrearActividad: "",
    estadoModalCrear: true,

    datosSeccion: [],
    datosClase: [],
    tipoNotasCalificacion: [],
    fechaActual: "",
    fechaSeleccionada: "",

    eventoAct: "",
    eventoActividad: "",
    ////////////////////////////

    // modal evaluar actividad
    tituloEvalucionNivel: "",
    tituloEvalucionNivelColor: "",
    tituloEvalucionGrado: "",
    tituloEvalucionSeccion: "",
    modal_evaluarActividad: false,
    seccionAlumno: [],

    AlumnosSeccion: [],


    actividad: [],

    //////////////////////////////////////
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),
  },

  mounted() {
    //this.listarTemas();
    this.loadMain();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },
    ////////////////////////////////////////////////////////

    filterActividades(e) {
      console.log(e);
      this.actividadesDocenteFilter = this.actividadesDocente.filter(
        (actividad) => {
          let texto = actividad.nombre_tema + " " + actividad.nombre_clase;
          if (texto.toLowerCase().search(this.search.toLowerCase()) >= 0) {
            return true;
          }

          return false;
        }
      );
    },
    //  ------- Cargar todos los registros principales al iniciar el componente   --------
    async loadMain() {
      try {
        let params = `/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/usuario/${this.datoLogin.id}`;
        let response = await axios.get(
          `/academico/actividades/docenteActividad${params}`
        );
        this.actividadesDocente = response.data.payload.ActividadesDocente;
        this.actividadesDocenteFilter = response.data.payload.ActividadesDocente;

        console.log(this.AlumnosSeccion);

      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error: ${error}`,
          tiempo: null,
        });
        //console.log(error)
      }
    },

    // editar cabecera de la actividad
    editItem(item) {
      this.tipoComponente2 = "ModalCrearActividades";
      this.estadoModalCrear = true;
      this.fechaSeleccionada = "";
      this.datosClase = item;
      this.eventoActividad = "editar";
    },

    /** 
     ___________________________________________
    | FUNCION OBTENER TIPOS DE CALIFICACIONES */
    async getNotaLiteralNivelGrado(items) {
      const params = {
        id_colegio: items.id_colegio,
        id_nivel: items.id_nivel,
        id_grado: items.id_grado,
        id_ano_lectivo: items.id_periodo, //Se aclara que el id perdio es el año lectivo actual
      };

      try {
        const response = await axios.get(
          `/academico/actividades/listNotaLiteral`,
          {
            params: params,
          }
        );

        this.tipoNotasCalificacion = response.data;
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },

    async evaluarItem(item) {
      // listNotaLiteral
      await this.getNotaLiteralNivelGrado(item);

      this.modal_evaluarActividad = true;
      this.eventoActividad = "calificar";
      await this.cargarAlumnos(item);
      this.tituloEvalucionNivel = item.desc_nivel;
      this.tituloEvalucionNivelColor = item.color_nivel;
      this.tituloEvalucionGrado = item.desc_grado;
      this.tituloEvalucionSeccion = item.nombre_seccion;
    },

    async cargarAlumnos(item) {
      try {
        //this.limpiarFormAct()
        let params = `/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/seccion/${item.id_seccion}/actividad/${item.id_actividad}/usuario/${this.datoLogin.id}`;
        let response = await axios.get(
          `/academico/actividades/editarActividad${params}`
        );
        let data = response.data;


        this.seccionAlumno = data.SeccionAlumno;
        this.AlumnosSeccion = this.seccionAlumno.filter(
          (el) => el.alumno_check == true
        );


        this.actividad = await Object.assign({}, item);
        this.actividad.id = item.id_actividad;
        this.actividad.id_usuario = this.datoLogin.id;
        this.actividad.evento = "evaluacion";
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error: ${error}`,
          tiempo: null,
        });
        //console.log(error)
      }
    },

    async saveItem() {
      try {
        // eslint-disable-next-line no-unused-vars
        var res = "";
        res = await axios.post("/academico/actividades/", {
          actividad: this.actividad,
          alumnos: this.AlumnosSeccion,
        });



        this.setEnviarMens({
          tipo: "S",
          mensaje: "¡Información creada con éxito!",
          tiempo: null,
        });
        this.savenotif();
        this.modal_evaluarActividad = false;
        this.loadMain();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async savenotif() {
      let titulo = ''
      let contenido = ''
      let filteredUsers = ''

      if (this.eventoActividad == "editar") {
        titulo = 'Se edito la actividad'
        contenido = 'Se califico la actividad asignada '
        filteredUsers = this.AlumnosSeccion.filter(user => user.alumno_check);
      } else {
        titulo = 'Se califico la actividad'
        contenido = 'Se califico la actividad asignada '
        filteredUsers = this.AlumnosSeccion.filter(user => user.calificacion_revision != null && user.fecha_revision == null)

      }

      const fechaActual = new Date();
      const horaActual = fechaActual.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      const datanotif = {

        id_colegio: this.datoLogin.id_colegio,
        id_ano_lectivo: this.datoLogin.id_ano_lectivo,
        titulo_notif: titulo,
        contenido_notif: contenido,
        id_perfil: this.datoLogin.id_perfil,
        id_usuario: this.datoLogin.id,
        fecha_notif: fechaActual,
        hora_notif: horaActual,
        id_seccion: this.actividad.id_seccion,
        id_curso: this.actividad.id_curso,
        tema_clase: this.actividad.nombre_clase,
        icon_notif: 'fas fa-edit',
        alumnos: filteredUsers,

      };
      try {
        const response1 = await axios.post("/notification/persona/addusernotif/", datanotif);
        this.setEnviarMens({ tipo: `${response1.data.messageT}`, mensaje: `${response1.data.message}`, tiempo: null });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //Descargar actvidades del estudiante
    async download(url) {
      console.log(url);
      await this.$Files["downloadFetch"]({ url });
      this.setEnviarMens({
        tipo: "S",
        mensaje: "¡Actividad descarga con éxito!",
        tiempo: null,
      });
    },

    eventMayus(valor) {
      // no pude capturar el index  index: ${i},

      console.log(` Valor: ${valor.toUpperCase()}`);

      // eventMayus
      // console.log('eventMayus')
      // console.log(e)
      // e.value = e.value.toUpperCase();
    },
  },
};
</script>